import { useEffect, useState } from 'react';
import { totalCountEvent } from 'services/generalServices';
import { getCaseMatter } from 'services/lead/leadServices';

export function useCaseMatter(excludeFromLoading = false, practiceAreaId = '') {
  const [caseMatterList, setCaseMatterList] = useState([]);
  const [isCaseMatterLoading, setIsCaseMatterLoading] = useState(false);

  const loadCaseMatter = (practiceAreaId = '') => {
    setIsCaseMatterLoading(true);

    totalCountEvent('case-matter')
      .then((response) => {
        getCaseMatter({ pageLimit: response.data, excludeFromLoading: excludeFromLoading, practiceAreaId: practiceAreaId })
          .then((res) => setCaseMatterList(res.data?.['case-matter'] || []))
          .catch((error) => console.error(error))
          .finally(() => setIsCaseMatterLoading(false));
      })
      .catch((err) => {
        setIsCaseMatterLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    loadCaseMatter(practiceAreaId);
  }, [practiceAreaId]);

  return { caseMatterList, isCaseMatterLoading, loadCaseMatter };
}
